<template>
	<common-transition-slide :active="showAlerts" @opened="maybeScrollToAlerts">
		<div ref="alerts">
			<core-alerts :alerts="alerts" />
		</div>
	</common-transition-slide>
</template>

<script>
export default {
	props: {
		alerts: {
			type: Array,
			required: true,
		},
	},
	computed: {
		showAlerts() {
			return Boolean(this.alerts.length);
		},
	},
	watch: {
		alerts(updated) {
			if (updated && updated.length) {
				this.maybeScrollToAlerts();
			}
		},
	},
	methods: {
		maybeScrollToAlerts() {
			const $el = this.$get('$refs.alerts');
			if (!$el || !$el.getBoundingClientRect || !$el.scrollIntoView) {
				return;
			}
			const bounds = $el.getBoundingClientRect();
			const inViewport =
				0 <= bounds.top &&
				0 <= bounds.left &&
				bounds.right <= (window.innerWidth || document.documentElement.clientWidth) &&
				bounds.bottom <= (window.innerHeight || document.documentElement.clientHeight);
			if (!inViewport) {
				$el.scrollIntoView(false);
			}
		},
	},
};
</script>
